import React, { useEffect } from 'react'

import { RecallStatus } from '@pkg/types/interview'

import api from '@/api'

export const useWaitForRecallFinish = ({
  interviewId,
  recallStatus,
  setRecallStatus,
  setIsFullTranscriptGenerating,
}: {
  interviewId: string
  recallStatus: RecallStatus | undefined
  setRecallStatus: React.Dispatch<
    React.SetStateAction<RecallStatus | undefined>
  >
  setIsFullTranscriptGenerating: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  useEffect(() => {
    if (!recallStatus || recallStatus === 'done') {
      return
    }

    console.log('Start waiting for recall status to change')
    const interval = setInterval(async () => {
      const newInterview = (await api.getInterview(interviewId)).data.interview
      if (newInterview.recallStatus === 'done') {
        console.log('Recall meeting finished', {
          newInterview,
        })
        clearInterval(interval)

        console.log('Recall recording done')
      }

      setIsFullTranscriptGenerating(
        newInterview.isFullTranscriptGenerating || false,
      )
      setRecallStatus(newInterview.recallStatus || undefined)
    }, 30000)
    return () => clearInterval(interval)
  }, [interviewId, recallStatus])
}
